import {lazy} from 'react';

export const ClinicPagebyIdAsync = lazy(() => import('./ClinicPagebyId'));
